var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('h1',[_vm._v("Forbidden")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }